const afterSaleRoutes = [
  {
    path: "/complaints",
    name: "complaints",
    component: () => import("@/views/sale/complaints.vue"),
    meta: {
      title: "投诉列表",
      keepAlive: true,
    },
  },
  {
    path: "/complaintsNew",
    name: "complaintsNew",
    component: () => import("@/views/sale/complaintsNew.vue"),
    meta: {
      title: "投诉列表(新)",
      keepAlive: true,
    },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: () => import("@/views/sale/feedback.vue"),
    meta: {
      title: "工单列表",
      keepAlive: true,
    },
  },
  {
    path: "/checkList",
    name: "checkList",
    component: () => import("@/views/sale/checkList.vue"),
    meta: {
      title: "核对订单",
      keepAlive: true,
    },
  },
  {
    path: "/orderFund",
    name: "orderFund",
    component: () => import("@/views/sale/orderFund.vue"),
    meta: {
      title: "订单明细",
      keepAlive: true,
    },
  },
  {
    path: "/refundManage",
    name: "refundManage",
    component: () => import("@/views/sale/refundManage.vue"),
    meta: {
      title: "退款管理",
      keepAlive: true,
    },
  },
  {
    path: "/complaintH5",
    name: "complaintH5",
    component: () => import("@/views/sale/complaintH5.vue"),
    meta: {
      title: "H5投诉列表",
    },
  },
];

export default afterSaleRoutes;
